require('prismjs/themes/prism-tomorrow.css');
// themes prism- coy, dark, funky, okadia, solarizedlight, tomorrow, twilight
require('normalize.css/normalize.css');
require('@fortawesome/fontawesome-svg-core/styles.css');
